import graphqlApiUrl from '@api/helpers/graphqlApiUrl';
import axios from 'axios';
import FetchException from '../../server/exceptions/FetchException';
import searchFaqsQuery from '../graphql/searchFaqs';

export const fetchFAQS = async (location, categoryGuid) => {
	const variables = {
		location: { city: location.city, state: location.stateCode },
		categoryGuid,
	};

	const data = {
		query: searchFaqsQuery,
		variables,
	};

	try {
		const response = await axios.post(graphqlApiUrl(), data);
		const { searchFaqs } = response.data.data;
		if (searchFaqs === null) {
			throw response.data.errors[0].message;
		}

		return searchFaqs.faqs;
	} catch (error) {
		throw new FetchException(error.message, variables);
	}
};
